import type { NavigateFunction } from 'react-router-dom';
import { ActionButton } from '@/shared/ui/ActionButton/ActionButton';
import classes from './FormButtons.module.scss';

interface FormButtonsProps {
    loading: boolean;
    disabled?: boolean;
    isEditMode?: boolean;
    id?: string;
    navigate: NavigateFunction;
    baseRoute?: string;
    customBackRoute?: string;
    createText?: string;
    editText?: string;
}

/** Показывает сохранение и возврат с едиными состояниями кнопок. */
const FormButtons: React.FC<FormButtonsProps> = (
    {
        loading,
        disabled = false,
        isEditMode = false,
        id,
        navigate,
        baseRoute = null,
        customBackRoute = null,
        createText = 'Создать',
        editText = 'Сохранить изменения',
    }
) => {
    const loadingText = isEditMode
        ? 'Сохранение...'
        : 'Создание...';

    const successText = isEditMode
        ? editText
        : createText;

    const backPath = isEditMode
        ? `${baseRoute}/${id}`
        : baseRoute;

    /** Возвращает сотрудника из формы */
    const handleClick = () => {
        if (customBackRoute)
            navigate(customBackRoute);
        else if (backPath) {
            navigate(backPath);
        } else {
            navigate(-1);
        }
    };

    return (
        <div className={classes.actions}>
            <ActionButton
                type="submit"
                disabled={loading || disabled}
                loading={loading}
                label={loading
                    ? loadingText
                    : successText
                }
                color="primary"
            />
            <ActionButton
                type="button"
                onClick={handleClick}
                disabled={loading}
                label="Назад"
                color="secondary"
                outlined
            />
        </div>
    );
};

export default FormButtons;
